export const handlePermissions = async () => {
  let permissions = {
    audio: false,
    video: false,
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videoDevices = devices.filter((d) => d.kind === 'videoinput')
    const audioDevices = devices.filter((d) => d.kind === 'audioinput')

    console.log("Available video devices:")
    console.log(videoDevices)
    console.log("Available audio devices:")
    console.log(audioDevices)

    // Pick the first video and audio device found
    const selectedVideoDeviceId = videoDevices[0]?.deviceId
    const selectedAudioDeviceId = audioDevices[0]?.deviceId
    console.log("Selected Video DeviceId: " + selectedVideoDeviceId)
    console.log("Selected Audio DeviceId: " + selectedAudioDeviceId)

    const stream = await navigator.mediaDevices.getUserMedia({
      video: selectedVideoDeviceId ? { deviceId: { exact: selectedVideoDeviceId } } : true,
      audio: selectedAudioDeviceId ? { deviceId: { exact: selectedAudioDeviceId } } : true,
    })

    for (const track of stream.getTracks()) {
      track.stop()
    }

    permissions = { video: true, audio: true }
  } catch (err) {
    permissions = { video: false, audio: false }
    console.error('getUserMedia error:', err.message)
  }

  if (!permissions.video) {
    console.error('Failed to get video permissions.')
  } else if (!permissions.audio) {
    console.error('Failed to get audio permissions.')
  }

  return permissions
}

export const getAvailableDevices = async () => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videoDevices = devices.filter((d) => d.kind === 'videoinput')
    return videoDevices
  } catch (error) {
    console.log(error)
  }
}

export const getStreamFromDevice = async (videoDeviceId) => {
  try {
    const cameraStream = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: { exact: videoDeviceId },
      },
    })

    return cameraStream
  } catch (error) {
    console.log(error)
  }
}

export const dataURLtoBlob = async (dataURL) => {
  const response = await fetch(dataURL)
  const blob = await response.blob()
  return blob
}
